import React from 'react'
import { defineMessage } from 'react-intl'

import { getCarelonDefaultWorkLifeServices } from './default'
import { WorkLifeIconDependentCare } from '../atoms/icons/WorkLifeIcons'
import { BulletText as WorkLifeBulletText } from '../organisms/workLifeCard/WorkLifeCard'

/* eslint-disable formatjs/no-literal-string-in-jsx */

export const commonspirit = () => {
  const CARELON_WORKLIFE_SERVICES = getCarelonDefaultWorkLifeServices('commonspirit')
  return {
    dependentButtonText: defineMessage({
      defaultMessage: 'No, I’m a dependent or household member',
      description: 'Declaring the current user is a dependent of an eligible user',
    }),
    workLifeServices: [
      CARELON_WORKLIFE_SERVICES.LEGAL_SERVICES,
      CARELON_WORKLIFE_SERVICES.FINANCIAL_SERVICES,
      CARELON_WORKLIFE_SERVICES.IDENTITY_THEFT,
      CARELON_WORKLIFE_SERVICES.DEPENDENT_CARE,
      {
        identifiers: {
          id: 'care',
          dataTestId: 'workLife-selectCare',
        },
        title: 'Care.com',
        iconSvg: <WorkLifeIconDependentCare size={48} />,
        paragraph: 'Care Membership',
        bullets: [
          'Access to ongoing care providers - for children, seniors, pets, tutoring, housekeeping, and more',
          <WorkLifeBulletText
            key='care-backup-care'
            text={'Backup Care \nSubsidized coverage when regular care is unavailable - for children, seniors, pets'}
          />,
        ],
        CTA: 'Access Care.com',
        PATH: 'https://commonspirit.care.com/app/ent-memberhome/commonspirit',
      },
    ],
  }
}
